import { SIDEBAR_STATE_TYPES } from './sidebarStateActionTypes';

export const updateMobileSidebarVisible = (payload: boolean) => ({
  type: SIDEBAR_STATE_TYPES.UPDATE_MOBILE_SIDEBAR_VISIBLE,
  payload,
});
